/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menureadingfulltitle3Inputs */

const en_menureadingfulltitle3 = /** @type {(inputs: Menureadingfulltitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pulsify is reading your menu`)
};

const de_menureadingfulltitle3 = /** @type {(inputs: Menureadingfulltitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pulsify liest deine Speisekarte`)
};

/**
* | output |
* | --- |
* | "Pulsify is reading your menu" |
*
* @param {Menureadingfulltitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menureadingfulltitle3 = /** @type {((inputs?: Menureadingfulltitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menureadingfulltitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menureadingfulltitle3(inputs)
	return de_menureadingfulltitle3(inputs)
});
export { menureadingfulltitle3 as "menuReadingFullTitle" }